import { getUserBonusHistory } from "@actions/bonus";
import { goToLink } from "@actions/common";
import { showAlert } from "@components/alert/action";
import Loading from "@components/loading/index.jsx";
import FreeSpinItem from "@pages/profile-v2/pages/bonuses/containers/FreeSpin/Item";
import PaginationWrapper from "@pages/profile-v2/pages/bonuses/containers/Pending/Pagination";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import NoContent from "../../../history-v2/components/NoContent";
import { BonusWrapper } from "../../elements";
import BonusItem from "./BonusItem";

const Completed = ({
	getUserBonusHistory,
	bonusList,
	offsetToken,
	translate,
	freespinHistory,
	goToLink,
	showAlert,
}) => {
	const rootRef = React.useRef(null);
	const [page, setPage] = React.useState(0);
	const [openIndex, setOpenIndex] = React.useState(-1);
	const [loading, setLoading] = React.useState(false);

	const onPaginate = (page, cb) => {
		if (offsetToken === undefined || !!offsetToken) {
			setLoading(true);
			getUserBonusHistory(
				{ params: { size: 50, lastItem: offsetToken, type: "BonusDeposit" } },
				() => {
					setLoading(false);
					cb();
				}
			);
			setPage(page);
		}
	};

	useEffect(() => {
		setLoading(true);
		getUserBonusHistory({ params: { size: 50, type: "BonusDeposit" } }, () => {
			setLoading(false);
		});
	}, []);

	const filteredBonusList = bonusList
		? bonusList.filter(
				(item) =>
					item.bonus &&
					item.bonus.instruction.type !== "Freespin" &&
					item.walletContributions[0].wageringRatio === 100
			)
		: [];

	const isFromFreeSpinHistory = filteredBonusList.length > 0 && "amount" in filteredBonusList[0];

	return loading ? (
		<Loading loading={loading} />
	) : filteredBonusList?.length === 0 ? (
		<NoContent
			translate={translate}
			title={"NoInfoText"}
			description={"NoInfoBonus"}
			noBackground={true}
		/>
	) : (
		<div
			style={{ width: "100%" }}
			ref={rootRef}>
			<PaginationWrapper
				initialBind={true}
				page={page}
				root={rootRef}
				onPaginate={onPaginate}>
				<BonusWrapper>
					{filteredBonusList.map((item, index) => (
						<BonusItem
							key={item.transactionId}
							data={item}
							index={index}
							translate={translate}
							openIndex={openIndex}
							setOpenIndex={setOpenIndex}
						/>
					))}
					{isFromFreeSpinHistory &&
						freespinHistory
							?.filter((item) => item.amount === 0)
							.map((item, index) => (
								<FreeSpinItem
									key={item?.key}
									data={item}
									goToLink={goToLink}
									translate={translate}
									showAlert={showAlert}
									index={index}
									isCompletedPage
								/>
							))}
				</BonusWrapper>
			</PaginationWrapper>
		</div>
	);
};

const mapStateToProps = (state) => ({
	bonusList: state.bonus.bonusHistory.reports,
	offsetToken: state.bonus.bonusHistory.offset,
	freespinHistory: state.profile.freespinHistory,
});

const mapDispatchToProps = {
	getUserBonusHistory,
	goToLink,
	showAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(Completed);
